import MfSelfService from 'ui/mfs/MfSelfService';

const TipsAndTraining = () => <MfSelfService document="dicas_e_treinamentos" />;

export default TipsAndTraining;
